export default __webpack_public_path__ + "static/media/606.1c783e5c.jpg";